import { ADDRESS_PAGE } from '@constants/formNames';
import { AddressPageFormValues } from '@features/Address/types';
import { GetLocalSessionAddressDetailsQuery } from '@generated/gql/graphql';

const parseAddressFormInput = (
  basketAddress: GetLocalSessionAddressDetailsQuery
): AddressPageFormValues => {
  if (!basketAddress) {
    return null;
  }

  const { occupancyType, supplyAddress } = basketAddress.basket?.details || {};

  if (!supplyAddress) {
    return null;
  }

  const {
    buildingName,
    buildingNumber,
    county,
    dependentThoroughfare,
    doubleDependentLocality,
    id,
    organisation,
    postTown,
    postcode,
    subBuilding,
    thoroughfare,
  } = supplyAddress;

  return {
    [ADDRESS_PAGE]: {
      addressSelection: id,
      buildingName: buildingName ?? '',
      buildingNumber: buildingNumber ?? '',
      county: county ?? '',
      dependentThoroughfare: dependentThoroughfare ?? '',
      doubleDependentLocality: doubleDependentLocality ?? '',
      homeOwnerSelection: occupancyType,
      manualEntry: !id,
      organisation: organisation ?? '',
      postTown: postTown ?? '',
      postcode,
      subBuilding: subBuilding ?? '',
      thoroughfare: thoroughfare ?? '',
    },
  };
};

export { parseAddressFormInput };
